import React from 'react';
import ReactDOM from 'react-dom';
import LoadingSmall from '../components/LoadingSmall.js';
import Notification from './Notification';
import axios from 'axios';
import Select from 'react-select';



class EmailListPicker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            'isLoading':true,
            'lists':[],
            'error':false,
            'isCreating':false,
            'list_name':''
        };

        this.currentList = this.currentList.bind(this);
        this.subscriberCount = this.subscriberCount.bind(this);
        this.onChange = this.onChange.bind(this);

    }

    onChange(e) {
        this.props.handleChangeList(e);
    }

    subscriberCount() {
        let list = this.currentList();

        if(!list) {
            return 0;
        }

        return list.subscribers_count;
    }

    getLists() {
        this.isLoading(true);
        axios.get('/newsletters/lists').then(res => {
            this.isLoading(false);
            this.setState({
                isLoading:false,
                lists:res.data,
            });
        });
    }

    isLoading = (val) => {
        this.props.handleLoadingChange(val);
    }


    buildList() {
        let list = [];

        this.state.lists.map(item => {
            list.push({
                'label':item.name,
                'value':item.id,
            })
        });

        return list;
    }

    componentWillMount() {
        this.getLists();
    }

    currentList() {

        for(let i in this.state.lists) {
            if(this.props.listId == this.state.lists[i].id) {
                return this.state.lists[i];
            }
        }

        return false;
    }

    render() {
        if(this.state.isLoading) {
            return (
                <div className="col-sm-12">
                    <LoadingSmall/>
                </div>
            );
        }

        if(this.state.error !== false) {
            return (
                <div className="col-sm-12">
                    <div className="alert alert-danger alert-dismissible" role="alert">
                        {this.state.error}
                    </div>
                </div>
            );
        }

        return (
            <div className="col-sm-12 p-0">
                <div className="col-sm-8">
                    <Select
                        value={parseInt(this.props.listId)}
                        onChange={this.onChange}
                        options={this.buildList()}
                        placeholder="Select an existing audience"
                        simpleValue
                    />
                </div>

                <div className="col-sm-4 text-center">
                    {this.subscriberCount()}<br />
                    Subscribers
                </div>
            </div>
        );
    }
}




export default EmailListPicker;



// WEBPACK FOOTER //
// ./components/EmailListPicker.js